import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ReportCountryMappingService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  resolve(country: string): string {
    const prefix = `${this.cookieName(country)}=`;
    const cookie = this.document.cookie
      .split(";")
      .map(value => value.trim())
      .find(value => value.startsWith(prefix));

    return cookie === undefined
      ? country
      : decodeURIComponent(cookie.substring(prefix.length));
  }

  remember(country: string, replacement: string): void {
    const name = this.cookieName(country);
    const secure = this.document.location.protocol === "https:" ? "; Secure" : "";
    // No expiry: shared by tabs for the browser session, subject to session restore.
    const cookie = `${name}=${encodeURIComponent(replacement)}; Path=/; SameSite=Strict${secure}`;

    if (cookie.length > 4000) {
      throw new Error("The country replacement is too long to remember.");
    }

    this.document.cookie = country === replacement
      ? `${name}=; Path=/; SameSite=Strict${secure}; Max-Age=0`
      : cookie;

    if (this.resolve(country) !== replacement) {
      throw new Error("The country replacement could not be remembered. Check that cookies are enabled.");
    }
  }

  private cookieName(country: string): string {
    const encoded = encodeURIComponent(country).replace(
      /[!'()*]/g,
      character => `%${character.charCodeAt(0).toString(16).toUpperCase()}`
    );
    return `wedeReportCountry_${encoded}`;
  }
}
